export const workspaceKeys = {
  all: ['workspaces'] as const,
  lists: () => [...workspaceKeys.all, 'list'] as const,
  detail: (id: number) => [...workspaceKeys.all, 'detail', id] as const,
  members: (workspaceId: number) => [...workspaceKeys.detail(workspaceId), 'members'] as const,
  invites: (workspaceId: number) => [...workspaceKeys.detail(workspaceId), 'invites'] as const,
} as const;
